package one.healthium.logger

import co.touchlab.kermit.Logger
import kotlinx.browser.window

@Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")
fun setupJsErrorHandlers() {
    window.addEventListener("error", { event ->
        val error = (event as? ErrorEvent)?.error
        Logger.e("Uncaught JS error", error as? Throwable)
    })

    window.addEventListener("unhandledrejection", { event ->
        val reason = (event as? PromiseRejectionEvent)?.reason
        Logger.e("Unhandled promise rejection", reason as? Throwable)
    })
}

external interface ErrorEvent {
    val error: dynamic
}

external interface PromiseRejectionEvent {
    val reason: dynamic
}